export default "/assets/website/images/owl.video.play.png?7f01b07148f205f6e8258e92bbf652d9";